import { BaseWebComponent } from "../base-components/base-web-component.js";
import { ManagerHandlerAction, UIField, UISchema, User } from "@bonusmap/api-types";
// classe comune funzionalità di base per i componenti che gestiscono il contesto dei dati
// come DataCollector, DataSlot, DataBaseComponent
export abstract class DataContextComponent extends BaseWebComponent {
    static webComponentName: string = "";
    protected _templateId: string = ""; // No template needed
    protected contextData: Record<string, any> = {}; // Placeholder for context data
    public dataSource!: UISchema; // Placeholder for data source, can be set externally
    public action: ManagerHandlerAction = 'view'; // Default action is 'view', can be set externally
    constructor() {
        super();
        this.dataSource = window.dataSource;
        this.action = window.ACTION || 'view'; // Default action if not set
    }
}